const BASE = import.meta.env.VITE_API_BASE || '/api';
const TOKEN_KEY = '3lumpers.token';

export class ApiError extends Error {
  constructor(message, status, code, details) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

function buildUrl(path, params) {
  const url = `${BASE}${path}`;
  if (!params) return url;
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    if (Array.isArray(value)) value.forEach((v) => search.append(key, v));
    else search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `${url}?${qs}` : url;
}

async function request(path, { method = 'GET', body, params, signal } = {}) {
  const token = getToken();
  const res = await fetch(buildUrl(path, params), {
    method,
    credentials: 'include',
    signal,
    headers: {
      ...(body ? { 'content-type': 'application/json' } : {}),
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const text = await res.text();
  let payload = null;
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      payload = { raw: text };
    }
  }

  if (!res.ok) {
    const error = payload?.error || {};
    throw new ApiError(error.message || `Request failed (${res.status})`, res.status, error.code, error.details);
  }
  return payload;
}

export const api = {
  get: (path, params, opts) => request(path, { method: 'GET', params, ...opts }),
  post: (path, body, params) => request(path, { method: 'POST', body, params }),
  patch: (path, body) => request(path, { method: 'PATCH', body }),
  put: (path, body) => request(path, { method: 'PUT', body }),
  del: (path) => request(path, { method: 'DELETE' }),
};

/** Fetch a text/csv endpoint (exports). */
export async function downloadText(path, filename) {
  const res = await fetch(buildUrl(path), { credentials: 'include' });
  if (!res.ok) throw new ApiError('Export failed', res.status, 'export_failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
